import HomeNavbar from "./components/Navbar";
import Hero from "./components/Hero";
import HowItWorks from "./components/HowItWorks";
import Features from "./components/Features";
import Stats from "./components/Stats";
import HomeFooter from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function HomePage() {
  return (
    <main className="min-h-screen">
      <HomeNavbar />
      <Hero />
      <HowItWorks />
      <Features />
      <Stats />
      <HomeFooter />
      <BackToTop />
    </main>
  );
}
